import type { JSX } from "react";
import { useOnline } from "../../components/ui/useOnline";

/**
 * mobile-pwa Phase 5 (= offline cache 段階): navigator.onLine が false のとき固定
 * top banner で reader に offline を通知する。 online のときは DOM ゼロ (= null 返却)。
 *
 * 配置: App.tsx root に mount、 全 view (= reader / scenario-builder / accessibility-statement)
 * 横断で表示。 safe area inset 込で iOS notch に被らない padding。
 *
 * a11y: role="status" + aria-live="polite" で SR 通知。 reader-warning-* token で
 * light / dark 両 theme 対応、 警告系として黄色基調 (= amber)。
 *
 * 文言: 「オフラインです — 新しい scene の生成はできません」。 生成は AI API 経由で
 * 必須なので明確に伝える (= 過去 scene の閲覧は IndexedDB cache 配備後に部分動作)。
 */
export function OfflineIndicator(): JSX.Element | null {
  const online = useOnline();
  if (online) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="offline-indicator"
      className="fixed left-0 right-0 z-50 bg-reader-warning-bg text-reader-warning-fg text-center text-sm py-2 px-4 border-b border-reader-warning-border"
      style={{
        top: 0,
        paddingTop: "calc(env(safe-area-inset-top) + 0.5rem)",
        paddingLeft: "calc(env(safe-area-inset-left) + 1rem)",
        paddingRight: "calc(env(safe-area-inset-right) + 1rem)",
      }}
    >
      オフラインです — 新しい scene の生成はできません
    </div>
  );
}
